import emptyImage from '@fukuri-admins/assets/images/circle-checks.svg';
import { Button } from '@fukuri-admins/ui/common';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

export const ConductedStressAssessmentEmpty: React.FC = () => {
  return (
    <div className={styles.Empty}>
      <div className={styles.Empty__Content}>
        <img className={styles.Empty__Content__Image} src={emptyImage} alt='empty list image' />
        <div className={styles.Empty__Content__Description}>
          まだ実施済みのストレスチェックはありません
        </div>
        <Button as='a' href={ROUTES.STRESS_ASSESSMENTS.NEW}>
          ストレスチェックを実施
        </Button>
      </div>
    </div>
  );
};
